export const LIKE_SLUG = "/like"